import React, { useState, useRef } from 'react';
import { Button, Input } from '../../../components';
import { IoIosCloudUpload } from 'react-icons/io';
import { usePaymentReminder } from '../../../context/paymentReminderContext/PaymentReminderContextProvider';

const LoadFile = () => {
  const { uploadFile, isLoading } = usePaymentReminder(); // Use context
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null); // Add ref for file input

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/xml') {
      setSelectedFile(file);
      setError('');
    } else {
      setSelectedFile(null);
      setError('Please upload a valid XML file.');
    }
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!selectedFile) {
      setError('No file selected.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      await uploadFile(formData); // Call context API
    } catch (error) {
    } finally {
      setSelectedFile(null); // Reset file state
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Clear file input
      }
    }
  };

  return (
    <form
      className="flex bg-white m-10  p-5 rounded-2xl items-center"
      onSubmit={handleUpload}
    >
      <div>
        <Input
          type="file"
          label="Reminder File"
          accept=".xml" // Restrict file type to XML
          onChange={handleFileChange}
          ref={fileInputRef} // Attach ref to input
        />
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
      </div>
      <div className="mt-5">
        <Button type="submit" disabled={isLoading || !selectedFile}>
          <div>
            <IoIosCloudUpload />
          </div>
          <div>{isLoading ? 'Uploading...' : 'Upload'}</div>
        </Button>
      </div>
    </form>
  );
};

export default LoadFile;
